import { Id } from './payrun-query.types';

export const PayrunAPI = {
  amendmentsByPayrunId: (id?: Id) => `<%userArea%>/payruns/${id}/amendments`,
  amendmentByPayrunId: (id?: Id, amendmentId?: string) =>
    `<%userArea%>/payruns/${id}/amendment/${amendmentId}`,
  workersByPayrunId: (id?: Id) => `<%userArea%>/keypay/getEmployeesWithQuery/${id}`,
  workerDetailsById: (id?: Id, workerId?: Id) =>
    `<%userArea%>/payruns/${id}/getPayrunEmployeeLastPayAndYtd/${workerId}`,
  submitAmendmentsByPayrunId: (id: Id) => `<%userArea%>/payruns/${id}/amendments/submit`,
  milestonesByPayrunId: (id?: Id) => `<%userArea%>/payruns/${id}/milestones`,
  headerByPayrunId: (id?: Id) => `<%userArea%>/payruns/${id}/header`,
  approveEarningLinesByPayrunId: (id: Id) =>
    `/<%userArea%>/Payruns/${id}/payrunEarningLines`,
  changeLogByPayrunId: (id?: Id) => `api/v2/payruns/${id}/history`,
  earningLinesByPayrunId: (id?: Id) =>
    `<%userArea%>/payruns/${id}/getPayrunEmployeeTotals`,
  earningLineDetailsVarianceById: (id?: Id, workerId?: Id) =>
    `<%userArea%>/payruns/${id}/getPayrunEmployeeEarningLinesPreviousAndCurrent/${workerId}`,
  summaryByPayrunId: (id?: Id) => `<%userArea%>/payruns/${id}/getPayRunSummary`,
  filesByPayrunId: (id?: Id) => `<%userArea%>/payruns/${id}/getFiles`,
  fileByFileId: (id: Id) => `<%userArea%>/payruns/downloadFile/${id}`,
  invoiceByPayrunId: (id?: Id) => `<%userArea%>/payruns/${id}/invoices`,
  payInvoiceByPayrunId: (id: Id) => `<%userArea%>/payruns/${id}/paymentmade`,
  //@Deprecated use V2 updatePayrunMilestones instead
  updatePayrunDates: '<%userArea%>/payruns/updatePayrunDates',
};
